<template>
  <section>
    <!-- top-menu -->
    <top-menu/>

    <div class="page-content authentication-content">
      <div class="container-fluid">
        <div class="page-content-inner">
          <div class="row">
            <!-- List Details -->
            <div class="col-md-12 box-default">
              <div class="col-md-12 authentication-card">
                <div class="authentication-card-header">
                  <div class="title-cancel-detail">
                    <label class="label-icon-authentication">
                      <ion-icon name="id-card-outline"></ion-icon>
                      Usuários e Logins
                    </label>
                    <span>Acompanhe todos os detalhes dos usuários e logins</span>
                  </div>
                </div>
                <div class="card-form-group">
                  <form v-on:submit.prevent="getListFilter()">
                    <div class="row">
                      <div class="table-box--form">
                        <div class="form-text-group col-md-4">
                          <label>Pesquisar usuário por CPF, e-mail ou ID <span>*</span></label>
                          <div class="form-text-default">
                            <input v-model="companyFilter" type="text" placeholder="CPF, e-mail ou ID"
                                   autocomplete="off">
                            <ion-icon name="search-outline"></ion-icon>
                          </div>
                          <span class="search-error" v-if="validateInput">* Preencha o campo</span>
                        </div>
                        <div class="form-button col-md-2">
                          <button type="submit">Pesquisar</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <full-loading class="full-loading-list" v-if="loadingList"/>
                <div v-if="!loadingList" class="authentication-card-content">
                  <div v-if="dataContent === ''"></div>
                  <div v-else-if="dataContent.length === 0" class="empty-state-group">
                    <img src="../../../../../assets/img/empty-state.png" alt="empty-state">
                    <div class="empty-state-text">
                      <span class="empty-state-title">Nenhum dado encontrado</span>
                      <span class="empty-state-subtitle">Caso esteja realizando alguma pesquisa, verifique os dados preenchidos e tente novamente!</span>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row authentication-results">
                      <div class="col-md-7 results-content">
                        <div class="results-header">
                          <span>Usuários</span>
                        </div>
                      </div>
                      <div class="col-md-5 results-content">
                        <div class="results-header">
                          <span>Logins</span>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div v-for="(value, index) in dataContent" class="results-body col-md-12" :key="index">
                          <div class="col-md-7 body-content body-user">
                            <div v-if="value.id !== null" class="content-global">
                              <div class="col-md-6 content-user">
                                <span class="user-title">Nome: <span>{{ value.name }}</span></span>
                                <span class="user-id">{{ value.id }}</span>
                                <span class="user-cpf">CPF: <span>{{ value.cpf | cpfOrCnpj }}</span></span>
                                <span class="user-email">E-mail: <span>{{ value.email }}</span></span>
                                <div class="user-btn">
                                  <div class="btn-status">
                                    <span v-if="value.active === true" class="btn-active active-active">
                                      <ion-icon name="checkmark-circle-outline"></ion-icon>
                                      Ativo
                                    </span>
                                    <span v-if="value.active === false" class="btn-active active-disabled">
                                      <ion-icon name="close-outline"></ion-icon>
                                      Desativado
                                    </span>

                                    <span v-if="value.active === true"
                                          @click="changeStatus('userActive', false, value.id, value.contextCode)"
                                          class="btn-change change-disabled">
                                      <span>
                                        <ion-icon name="close-outline"></ion-icon>
                                        Desativar
                                      </span>
                                    </span>
                                    <span v-if="value.active === false"
                                          @click="changeStatus('userActive', true, value.id, value.contextCode)"
                                          class="btn-change change-active">
                                      <span>
                                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                                        Ativar
                                      </span>
                                    </span>
                                  </div>

                                  <div class="btn-deleted">
                                    <span v-if="value.deleted === false" class="btn-active active-active">
                                      <ion-icon name="checkmark-circle-outline"></ion-icon>
                                      Não deletado
                                    </span>
                                    <span v-if="value.deleted === true" class="btn-active active-disabled">
                                      <ion-icon name="trash-outline"></ion-icon>
                                      Deletado
                                    </span>

                                    <span v-if="value.deleted === false"
                                          @click="changeStatus('userDeleted', true, value.id, value.contextCode)"
                                          class="btn-change change-disabled">
                                      <span>
                                        <ion-icon name="trash-outline"></ion-icon>
                                        Deletar
                                      </span>
                                    </span>
                                    <span v-if="value.deleted === true"
                                          @click="changeStatus('userDeleted', false, value.id, value.contextCode)"
                                          class="btn-change change-active">
                                      <span>
                                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                                        Recuperar
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 content-company">
                                <span class="company-title">Empresa:</span>
                                <span class="company-title-content"><span>{{ value.companyName }}</span></span>
                                <span class="company-id">{{ value.companyId }}</span>
                                <div class="company-btn">
                                  <div class="btn-status">
                                  <span v-if="value.companyActive === true" class="btn-active active">
                                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                                    Ativo
                                  </span>
                                    <span v-if="value.companyActive === false" class="btn-active disabled">
                                    <ion-icon name="close-outline"></ion-icon>
                                    Desativado
                                  </span>
                                  </div>
                                  <div class="btn-deleted">
                                  <span v-if="value.companyDeleted === false" class="btn-active active">
                                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                                    Não deletada
                                  </span>
                                    <span v-if="value.companyDeleted === true" class="btn-active disabled">
                                    <ion-icon name="trash-outline"></ion-icon>
                                    Deletado
                                  </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-else class="content-empty">
                              <span>
                                <ion-icon name="person-circle-outline"></ion-icon>
                                Nenhum usuário encontrado
                              </span>
                            </div>
                          </div>
                          <div class="col-md-5 body-content body-login">
                            <div v-if="value.authList.length === 0" class="login-body">
                              <div class="login-empty">
                                <span class="empty-title">Login ID:</span>
                                <span class="empty-content">
                                  <ion-icon name="close-circle-outline"></ion-icon>
                                  Nenhum login vinculado
                                </span>
                                <span @click="createLogin(value.id, value.contextCode)" class="btn-empty">
                                  Criar login
                                </span>
                              </div>
                            </div>
                            <div v-else class="login-body">
                              <div v-for="(logins, loginIndex) in value.authList"
                                   :style="logins.length > 1 ? 'margin-bottom: 16px;' : 'margin-bottom: 0;'"
                                   class="col-md-12 content-login"
                                   :key="loginIndex">
                                <span class="login-title">Login ID:</span>
                                <span class="login-id">{{ logins.id }}</span>
                                <span class="login-cpf">CPF: <span>{{ logins.cpf |cpfOrCnpj }}</span></span>
                                <span class="login-email">E-mail: <span>{{ logins.email }}</span></span>
                                <div class="login-btn">
                                  <div class="btn-status">
                                    <span v-if="logins.active === true" class="btn-active active-active">
                                      <ion-icon name="checkmark-circle-outline"></ion-icon>
                                      Ativo
                                    </span>
                                    <span v-if="logins.active === false" class="btn-active active-disabled">
                                      <ion-icon name="close-outline"></ion-icon>
                                      Desativado
                                    </span>

                                    <span v-if="logins.active === true"
                                          @click="changeStatus('loginActive', false, logins.id)"
                                          class="btn-change change-disabled">
                                      <span>
                                        <ion-icon name="close-outline"></ion-icon>
                                        Desativar
                                      </span>
                                    </span>
                                    <span v-if="logins.active === false"
                                          @click="changeStatus('loginActive', true, logins.id)"
                                          class="btn-change change-active">
                                      <span>
                                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                                        Ativar
                                      </span>
                                    </span>
                                  </div>

                                  <div class="btn-deleted">
                                    <span v-if="logins.deleted === false" class="btn-active active-active">
                                      <ion-icon name="checkmark-circle-outline"></ion-icon>
                                      Não deletado
                                    </span>
                                    <span v-if="logins.deleted === true" class="btn-active active-disabled">
                                      <ion-icon name="trash-outline"></ion-icon>
                                      Deletado
                                    </span>

                                    <span v-if="logins.deleted === false"
                                          @click="changeStatus('loginDeleted', true, logins.id)"
                                          class="btn-change change-disabled">
                                      <span>
                                        <ion-icon name="trash-outline"></ion-icon>
                                        Deletar
                                      </span>
                                    </span>
                                    <span v-if="logins.deleted === true"
                                          @click="changeStatus('loginDeleted', false, logins.id)"
                                          class="btn-change change-active">
                                      <span>
                                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                                        Recuperar
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import {
  CREATE_USER_LOGIN,
  GET_AUTHENTICATION,
  UPDATE_LOGIN_ACTIVE, UPDATE_LOGIN_DELETED,
  UPDATE_USER_ACTIVE,
  UPDATE_USER_DELETED
} from "../../../../../urlConfig";
import {UTIL_SERVICE} from "../../../../../utils";
import {REQUEST_SERVICE} from "../../../../../requestConfig";
import {ALERT_SERVICE} from "../../../../../msgAlertService";
import swal from "sweetalert";

export default {
  name: "userLoginDetail",
  components: {
    topMenu,
    fullLoading,
  },
  data() {
    return {
      loadingList: false,
      validateInput: false,
      companyFilter: '',
      dataContent: '',
      context: '',
      requestedValue: '',
    }
  },
  methods: {
    getListFilter() {
      let url = GET_AUTHENTICATION;
      let valueFilter = '';

      if (this.companyFilter === '') {
        this.validateInput = true
        return
      }

      if (this.companyFilter) {
        this.validateInput = false
      }

      if (this.companyFilter.includes(".") && this.companyFilter.includes("-")) {
        valueFilter = this.companyFilter.replace(/[^0-9]/g, '');
      } else {
        valueFilter = this.companyFilter
      }

      url = url + '/' + valueFilter

      this.validateInput = false
      this.loadingList = true;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT ORDERS_BENEFITS:", response.data);
          this.dataContent = response.data;
          this.requestedValue = valueFilter;
          this.loadingList = false;

          $(".card-form-group").css('margin-bottom', '30px')

        }).catch((reason) => {
        this.loadingList = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);

      });
    },
    changeStatus(location, status, id, context) {
      let url = ''
      let typeObj = ''
      let objUser = "?i=" + this.$route.params.userInfo.id + "&userId=" + id + "&context=" + context
      let objLogin = "?i=" + this.$route.params.userInfo.id + "&authId=" + id
      let textSwal = ''
      let btnTextSwal = ''

      if (location === 'userActive' || location === 'userDeleted') {
        typeObj = '0';
        objUser = objUser + "&status=" + status

        if (location === 'userActive') {
          url = UPDATE_USER_ACTIVE + objUser
        }

        if (location === 'userDeleted') {
          url = UPDATE_USER_DELETED + objUser
        }
      }

      if (location === 'loginActive' || location === 'loginDeleted') {
        typeObj = '1';
        objLogin = objLogin + "&status=" + status

        if (location === 'loginActive') {
          url = UPDATE_LOGIN_ACTIVE + objLogin
        }

        if (location === 'loginDeleted') {
          url = UPDATE_LOGIN_DELETED + objLogin
        }
      }

      if (location === 'userActive') {
        if (status === true) {
          textSwal = 'Tem certeza que deseja ativar este usuário?'
          btnTextSwal = 'Ativar'
        }

        if (status === false) {
          textSwal = 'Tem certeza que deseja desativar este usuário?'
          btnTextSwal = 'Desativar'
        }
      }

      if (location === 'userDeleted') {
        if (status === false) {
          textSwal = 'Tem certeza que deseja recuperar este usuário?'
          btnTextSwal = 'Recuperar'
        }

        if (status === true) {
          textSwal = 'Tem certeza que deseja deletar este usuário?'
          btnTextSwal = 'Deletar'
        }
      }

      if (location === 'loginActive') {
        if (status === true) {
          textSwal = 'Tem certeza que deseja ativar este login?'
          btnTextSwal = 'Ativar'
        }

        if (status === false) {
          textSwal = 'Tem certeza que deseja desativar este login?'
          btnTextSwal = 'Desativar'
        }
      }

      if (location === 'loginDeleted') {
        if (status === false) {
          textSwal = 'Tem certeza que deseja recuperar este login?'
          btnTextSwal = 'Recuperar'
        }

        if (status === true) {
          textSwal = 'Tem certeza que deseja deletar este login?'
          btnTextSwal = 'Deletar'
        }
      }

      UTIL_SERVICE.createSwal('Aviso!', textSwal, 'warning', btnTextSwal)
        .then((value) => {
          switch (value) {
            case "confirm":
              UTIL_SERVICE.console("URL SEARCH:", url);
              REQUEST_SERVICE.put(url)
                .then((response) => {
                  swal("Aviso", response.data, "success");
                  this.getReloadListFilter();
                }).catch((reason) => {
                swal("Aviso", reason.response.data, "error");
              });
              break;

            default:
              swal("Cancelado!", {
                icon: "error",
              });
          }
        });
    },
    createLogin(id, context) {
      swal({
        title: "Aviso!",
        text: 'Tem certeza que deseja criar um login para este usuário?',
        icon: "warning",
        buttons: {
          cancel: "Cancelar",
          catch: {
            text: 'Criar login',
            value: "confirm",
          }
        },
      })
        .then((value) => {
          let url = CREATE_USER_LOGIN + "?i=" + this.$route.params.userInfo.id + "&userId=" + id + "&context=" + context

          switch (value) {
            case "confirm":
              UTIL_SERVICE.console("URL SEARCH:", url);
              REQUEST_SERVICE.post(url)
                .then((response) => {
                  swal("Aviso", response.data, "success");
                  this.getReloadListFilter();
                }).catch((reason) => {
                ALERT_SERVICE.showMsgError(reason.response.data.erros);
              });
              break;

            default:
              swal("Cancelado!", {
                icon: "error",
              });
          }
        });
    },
    getReloadListFilter() {
      let url = GET_AUTHENTICATION;
      url = url + '/' + this.requestedValue

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT ORDERS_BENEFITS:", response.data);
          this.dataContent = response.data;
        }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
  },
}
</script>

<style lang="scss">

.authentication-content {
  .box-default {
    border-radius: 10px !important;
    padding: 20px 20px 30px 20px;
    background: #ffffff;

    .authentication-card {
      padding: 0;

      .full-loading-list {
        border: none;
        box-shadow: none;
      }

      .authentication-card-header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--classic-gray);

        .title-cancel-detail {
          padding: 0;

          .label-icon-authentication {
            margin: 0;
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);

            ion-icon {
              margin-right: 5px;
              font-size: 23px;
              color: var(--dark-gray);
            }
          }

          span {
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }

        .cancel-detail-total {
          position: relative;

          color: var(--dark-gray);
          font-size: 16px;
          font-weight: 500;

          .btn-excel {
            position: absolute;
            bottom: -15px;
            right: 0;

            display: flex;
            align-items: center;

            padding: 4px 20px;
            background: var(--light-green);
            color: #ffffff;
            border-radius: 4px !important;
            border: none;
            text-decoration: none;

            &:hover {
              background: #17a24f;
            }

            span {
              font-size: 14px;
            }

            ion-icon {
              margin-right: 5px;
            }
          }
        }
      }

      .card-form-group {
        margin-top: 10px;

        .table-box--form {
          display: flex;

          .form-text-group {
            display: flex;
            flex-direction: column;
            padding-right: 10px;

            label {
              font-size: 14px;
              font-weight: 400;
              color: #191919;
              margin-bottom: 4px;

              span {
                color: var(--light-red);
              }
            }

            .form-text-default {
              display: flex;
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 12px;
                font-size: 16px;
                color: var(--dark-gray);
              }

              input {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 8.5px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;

                font-size: 16px;
                font-weight: 400;
                color: var(--high-gray);

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--high-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .form-datepicker-group {
            display: flex;
            flex-direction: column;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .datepicker-group {
              position: relative;

              .vdp-datepicker {
                display: inline-block;
                width: 100%;

                .datepicker-style {
                  width: 100%;
                  background: #EEF2F7;
                  border-radius: 4px !important;
                  padding: 8.5px 12px;
                  border: 1px solid #EEF2F7;
                  transition: .2s;

                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);

                  &::placeholder {
                    font-size: 16px;
                    font-weight: 400;
                    color: var(--dark-gray);
                  }

                  &:hover {
                    transition: .2s;
                    border: 1px solid #cacaca;
                  }

                  &:focus-visible {
                    outline: none;
                    transition: .2s;
                    border: 1px solid #cacaca;

                    &::placeholder {
                      transition: .1s;
                      color: #EEF2F7;
                    }
                  }
                }
              }

              i {
                position: absolute;
                right: 15px;
                top: 12px;
                color: #111;
                cursor: pointer;
              }
            }
          }

          .form-select {
            display: flex;
            flex-direction: column;

            .form-select-input {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 12px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;
              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 8.5px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .form-button {
            padding-right: 0;
            padding-left: 10px;

            button {
              margin-top: 25.5px;
              background: #2F23D6;
              color: #ffffff;
              border-radius: 4px !important;
              border: none;
              padding: 10px 20px;
              transition: .2s;

              &:hover {
                background: #20179e;
              }
            }
          }
        }
      }

      .authentication-card-content {
        .empty-state-group {
          text-align: center;
          margin-top: 2rem;
          margin-bottom: 6rem;

          img {
            margin-bottom: 2rem;
          }

          .empty-state-text {
            display: flex;
            justify-content: center;
            flex-direction: column;

            width: 45%;
            margin: auto;

            .empty-state-title {
              font-weight: 700;
              font-size: 16px;
              color: var(--dark-gray);
            }

            .empty-state-subtitle {
              font-weight: 400;
              font-size: 16px;
              color: var(--dark-gray);
            }
          }
        }

        .authentication-results {
          .results-content {
            margin-bottom: 16px;

            &:first-child {
              padding-right: 5px;

              .results-header {
                width: 98%;
              }
            }

            &:last-child {
              padding-left: 0;
            }

            .results-header {
              padding-bottom: 8px;
              font-size: 21px;
              font-weight: 400;
              color: var(--dark-gray);
              border-bottom: 1px solid var(--classic-gray);
            }
          }

          .results-body {
            border: 1px solid var(--classic-gray);
            padding: 20px;
            border-radius: 10px !important;
            margin-bottom: 16px;

            span {
              word-break: break-all;
            }

            .body-content {
              padding: 0;

              &:last-child {
                padding-left: 10px;
              }

              .content-user {
                display: flex;
                flex-direction: column;
                width: calc(100% / 2);
                padding: 0;
                border-right: 1px solid var(--background-gray);

                .user-title {
                  font-size: 16px;
                  color: #191919;
                  line-height: 14px;

                  span {
                    font-weight: 700;
                  }
                }

                .user-id {
                  font-size: 12px;
                  font-weight: 400;
                  color: var(--dark-gray);
                  margin-bottom: 8px;
                }

                .user-cpf {
                  font-size: 16px;
                  font-weight: 400;
                  color: #191919;
                  margin-bottom: 8px;

                  span {
                    font-weight: 700;
                  }
                }

                .user-email {
                  font-size: 16px;
                  font-weight: 400;
                  color: #191919;
                  margin-bottom: 8px;

                  span {
                    font-weight: 700;
                  }
                }

                .user-btn {
                  display: flex;
                  flex-direction: row;
                  margin-top: 8px;

                  .btn-status {
                    display: flex;
                    flex-direction: column;
                    width: 142px;
                    margin-right: 4px;

                    .btn-active {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #FFFFFF;
                      font-size: 12px;
                      font-weight: 400;
                      padding: 6px 0;
                      border-radius: 4px !important;

                      ion-icon {
                        font-size: 14px;
                        margin-right: 4px;
                      }
                    }

                    .btn-change {
                      display: flex;
                      justify-content: center;
                      font-size: 12px;
                      font-weight: 400;
                      margin-top: 9px;

                      span {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: .2s;
                        cursor: pointer;
                      }

                      ion-icon {
                        font-size: 18px;
                        margin-right: 2px;
                      }
                    }

                    .active-active {
                      background-color: var(--light-green);
                    }

                    .active-disabled {
                      background-color: var(--light-red);
                    }

                    .change-active {
                      color: var(--light-green);

                      &:hover {
                        span {
                          color: #27c064;
                        }
                      }
                    }

                    .change-disabled {
                      color: var(--light-red);

                      &:hover {
                        span {
                          color: #d63f53;
                        }
                      }
                    }
                  }

                  .btn-deleted {
                    display: flex;
                    flex-direction: column;
                    width: 142px;
                    margin-left: 4px;
                    margin-right: 20px;

                    .btn-active {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #FFFFFF;
                      font-size: 12px;
                      font-weight: 400;
                      padding: 6px 0;
                      border-radius: 4px !important;

                      ion-icon {
                        font-size: 14px;
                        margin-right: 4px;
                      }
                    }

                    .btn-change {
                      display: flex;
                      justify-content: center;
                      font-size: 12px;
                      font-weight: 400;
                      margin-top: 9px;

                      span {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: .2s;
                        cursor: pointer;
                      }

                      ion-icon {
                        font-size: 18px;
                        margin-right: 2px;
                      }
                    }

                    .active-active {
                      background-color: var(--light-green);
                    }

                    .active-disabled {
                      background-color: var(--light-red);
                    }

                    .change-active {
                      color: var(--light-green);

                      &:hover {
                        span {
                          color: #27c064;
                        }
                      }
                    }

                    .change-disabled {
                      color: var(--light-red);

                      &:hover {
                        span {
                          color: #d63f53;
                        }
                      }
                    }
                  }
                }
              }

              .content-company {
                display: flex;
                flex-direction: column;
                width: calc(100% / 2);
                padding: 0 20px;

                .company-title {
                  font-size: 16px;
                  color: #191919;
                  line-height: 14px;
                  margin-bottom: 8px;
                }

                .company-title-content {
                  font-size: 16px;
                  color: #191919;
                  line-height: 14px;

                  span {
                    font-weight: 700;
                  }
                }

                .company-id {
                  font-size: 12px;
                  font-weight: 400;
                  color: var(--dark-gray);
                  margin-bottom: 8px;
                }

                .company-btn {
                  display: flex;
                  flex-direction: row;
                  margin-top: 8px;

                  .btn-status {
                    display: flex;
                    flex-direction: column;
                    width: 142px;
                    margin-right: 4px;

                    .btn-active {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #FFFFFF;
                      font-size: 12px;
                      font-weight: 400;
                      padding: 6px 0;
                      border-radius: 4px !important;

                      ion-icon {
                        font-size: 14px;
                        margin-right: 4px;
                      }
                    }

                    .active {
                      background-color: var(--light-green);
                    }

                    .disabled {
                      background-color: var(--light-red);
                    }
                  }

                  .btn-deleted {
                    display: flex;
                    flex-direction: column;
                    width: 142px;
                    margin-left: 4px;
                    transition: .2s;

                    .btn-active {
                      background-color: #2ACC6B;

                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #FFFFFF;
                      font-size: 12px;
                      font-weight: 400;
                      padding: 6px 0;
                      border-radius: 4px !important;

                      ion-icon {
                        font-size: 14px;
                        margin-right: 4px;
                      }
                    }

                    .active {
                      background-color: var(--light-green);
                    }

                    .disabled {
                      background-color: var(--light-red);
                    }
                  }
                }
              }

              .login-body {
                .login-empty {
                  display: flex;
                  flex-direction: column;
                  height: 164px;

                  .empty-title {
                    font-size: 16px;
                    font-weight: 700;
                    color: #191919;
                    margin-bottom: 16px;
                  }

                  .empty-content {
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    font-weight: 400;
                    color: var(--border-gray);
                    margin-bottom: 16px;

                    ion-icon {
                      font-size: 24px;
                      margin-right: 4px;
                      margin-left: 2px;
                      color: #BACADC;
                    }
                  }

                  .btn-empty {
                    border: 1px solid var(--high-blue);
                    border-radius: 8px !important;
                    font-size: 14px;
                    font-weight: 500;
                    padding: 6px 20px;
                    width: 115.45px;
                    color: var(--high-blue);
                    cursor: pointer;
                    transition: .2s;

                    &:hover {
                      background-color: var(--high-blue);
                      color: #FFFFFF;
                    }
                  }
                }

                .content-login {
                  display: flex;
                  flex-direction: column;
                  border-top: 1px solid var(--background-gray);
                  padding-top: 16px;
                  margin-bottom: 16px;

                  &:first-child {
                    border-top: none;
                    padding-top: 0;
                  }

                  .login-title {
                    font-size: 16px;
                    font-weight: 700;
                    color: #191919;
                    line-height: 14px;
                  }

                  .login-id {
                    font-size: 12px;
                    font-weight: 400;
                    color: var(--dark-gray);
                    margin-bottom: 8px;
                  }

                  .login-cpf {
                    font-size: 16px;
                    font-weight: 400;
                    color: #191919;
                    margin-bottom: 8px;

                    span {
                      font-weight: 700;
                    }
                  }

                  .login-email {
                    font-size: 16px;
                    font-weight: 400;
                    color: #191919;
                    margin-bottom: 8px;

                    span {
                      font-weight: 700;
                    }
                  }

                  .login-btn {
                    display: flex;
                    flex-direction: row;
                    margin-top: 8px;

                    .btn-status {
                      display: flex;
                      flex-direction: column;
                      width: 142px;
                      margin-right: 4px;

                      .btn-active {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #FFFFFF;
                        font-size: 12px;
                        font-weight: 400;
                        padding: 6px 0;
                        border-radius: 4px !important;

                        ion-icon {
                          font-size: 14px;
                          margin-right: 4px;
                        }
                      }

                      .btn-change {
                        display: flex;
                        justify-content: center;
                        font-size: 12px;
                        font-weight: 400;
                        margin-top: 9px;

                        span {
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          cursor: pointer;
                          transition: .2s;
                        }

                        ion-icon {
                          font-size: 18px;
                          margin-right: 2px;
                        }
                      }

                      .active-active {
                        background-color: var(--light-green);
                      }

                      .active-disabled {
                        background-color: var(--light-red);
                      }

                      .change-active {
                        color: var(--light-green);

                        &:hover {
                          span {
                            color: #27c064;
                          }
                        }
                      }

                      .change-disabled {
                        color: var(--light-red);

                        &:hover {
                          span {
                            color: #d63f53;
                          }
                        }
                      }
                    }

                    .btn-deleted {
                      display: flex;
                      flex-direction: column;
                      width: 142px;
                      margin-left: 4px;
                      margin-right: 20px;

                      .btn-active {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #FFFFFF;
                        font-size: 12px;
                        font-weight: 400;
                        padding: 6px 0;
                        border-radius: 4px !important;

                        ion-icon {
                          font-size: 14px;
                          margin-right: 4px;
                        }
                      }

                      .btn-change {
                        display: flex;
                        justify-content: center;
                        font-size: 12px;
                        font-weight: 400;
                        margin-top: 9px;

                        span {
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          cursor: pointer;
                          transition: .2s;
                        }

                        ion-icon {
                          font-size: 18px;
                          margin-right: 2px;
                        }
                      }

                      .active-active {
                        background-color: var(--light-green);
                      }

                      .active-disabled {
                        background-color: var(--light-red);
                      }

                      .change-active {
                        color: var(--light-green);

                        &:hover {
                          span {
                            color: #27c064;
                          }
                        }
                      }

                      .change-disabled {
                        color: var(--light-red);

                        &:hover {
                          span {
                            color: #d63f53;
                          }
                        }
                      }
                    }
                  }
                }
              }

              .content-empty {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 165px;

                span {
                  display: flex;
                  align-items: center;

                  font-size: 16px;
                  font-weight: 400;
                  color: var(--border-gray);

                  ion-icon {
                    margin-right: 4px;
                    font-size: 24px;
                    color: #BACADC;
                  }
                }
              }
            }

            .body-login {
              border-left: 1px solid var(--background-gray);
              padding-left: 20px !important;
            }
          }
        }
      }
    }
  }
}

.search-error {
  color: var(--light-red);
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/user/userLogin/userLoginDetail.vue